import type { AppLocale, MessageTree } from "@airange/shared/i18n-common";

export const redblueActivityDetailPageMessages: Record<AppLocale, MessageTree> = {
  "zh-CN": {
    redblue: {
      pages: {
        activityDetail: {
          title: "演练详情",
          tabs: {
            overview: "概览",
            topology: "动态靶场",
            members: "成员与席位",
            camps: "阵营席位",
            tasks: "剧本与任务",
            scoring: "评分与报告",
          },
          stats: {
            camps: "阵营",
            seats: "席位",
            tasks: "任务",
            totalScore: "总分",
            scoreRecords: "评分记录",
            reportCount: "报告总数",
            taskReportCount: "任务报告",
            freeReportCount: "自由报告",
          },
          cards: {
            baseInfo: "基础信息",
            topologyBinding: "拓扑绑定",
            reportTemplatesSnapshot: "报告模板快照",
          },
          fields: {
            activityName: "活动名称",
            activityCode: "活动编码",
            schemeVersion: "方案版本",
            judgeReview: "裁判复核",
            globalRanking: "全局排名",
          },
          members: {
            tableTitle: "成员分配网格",
            configureAction: "配置成员与席位",
            drawerTitle: "配置成员与席位",
            drawerNotice:
              "从分配格添加或编辑成员时，活动角色、所属阵营与席位由格子固定；导调员、裁判员、观察员不绑定阵营或席位。保存后同步更新成员快照。",
            drawerTableTitle: "成员配置",
            addMemberRow: "添加成员",
            emptySlot: "未分配",
            emptyAssignmentGroup: "当前分组暂无可分配席位；发布演练前请先补齐活动设计中的席位。",
            readonlyNotice: "当前活动不是草稿状态，成员与席位快照只读。",
          },
          topologyPreview: {
            title: "拓扑预览",
            ariaLabel: "活动绑定拓扑 X6 预览图",
            empty: "当前活动拓扑绑定没有可预览的 X6 快照。",
          },
        },
      },
    },
  },
  en: {
    redblue: {
      pages: {
        activityDetail: {
          title: "Activity Detail",
          tabs: {
            overview: "Overview",
            topology: "Dynamic Range",
            members: "Members and Seats",
            camps: "Camps and Seats",
            tasks: "Scripts and Tasks",
            scoring: "Scoring and Reports",
          },
          stats: {
            camps: "Camps",
            seats: "Seats",
            tasks: "Tasks",
            totalScore: "Total Score",
            scoreRecords: "Score Records",
            reportCount: "Reports",
            taskReportCount: "Task Reports",
            freeReportCount: "Free Reports",
          },
          cards: {
            baseInfo: "Basic Information",
            topologyBinding: "Topology Binding",
            reportTemplatesSnapshot: "Report Template Snapshot",
          },
          fields: {
            activityName: "Activity Name",
            activityCode: "Activity Code",
            schemeVersion: "Scheme Version",
            judgeReview: "Judge Review",
            globalRanking: "Global Ranking",
          },
          members: {
            tableTitle: "Member Assignment Grid",
            configureAction: "Configure Members and Seats",
            drawerTitle: "Configure Members and Seats",
            drawerNotice:
              "When adding or editing from an assignment cell, the activity role, camp, and seat are fixed by that cell. Director, Judge, and Observer do not bind a camp or seat. Saving updates the member snapshot.",
            drawerTableTitle: "Member Configuration",
            addMemberRow: "Add Member",
            emptySlot: "Unassigned",
            emptyAssignmentGroup:
              "This group has no assignable seats yet. Complete the activity design seats before publishing.",
            readonlyNotice:
              "This activity is not in draft status, so the member and seat snapshot is read-only.",
          },
          topologyPreview: {
            title: "Topology Preview",
            ariaLabel: "Activity bound topology X6 preview",
            empty: "This activity topology binding has no previewable X6 snapshot.",
          },
        },
      },
    },
  },
  ja: {
    redblue: {
      pages: {
        activityDetail: {
          title: "演習詳細",
          tabs: {
            overview: "概要",
            topology: "動的演習環境",
            members: "メンバーと席位",
            camps: "陣営と席位",
            tasks: "シナリオとタスク",
            scoring: "採点とレポート",
          },
          stats: {
            camps: "陣営",
            seats: "席位",
            tasks: "タスク",
            totalScore: "合計点",
            scoreRecords: "採点記録",
            reportCount: "レポート総数",
            taskReportCount: "タスクレポート",
            freeReportCount: "自由レポート",
          },
          cards: {
            baseInfo: "基本情報",
            topologyBinding: "トポロジー紐付け",
            reportTemplatesSnapshot: "レポートテンプレートスナップショット",
          },
          fields: {
            activityName: "演習名",
            activityCode: "演習コード",
            schemeVersion: "プラン版",
            judgeReview: "審判レビュー",
            globalRanking: "全体ランキング",
          },
          members: {
            tableTitle: "メンバー割り当てグリッド",
            configureAction: "メンバーと席位を設定",
            drawerTitle: "メンバーと席位を設定",
            drawerNotice:
              "割り当てセルから追加または編集する場合、活動ロール、陣営、席位はセルで固定されます。導調員、審判、観察者は陣営や席位に紐付けません。保存するとメンバースナップショットを更新します。",
            drawerTableTitle: "メンバー設定",
            addMemberRow: "メンバーを追加",
            emptySlot: "未割り当て",
            emptyAssignmentGroup:
              "このグループには割り当て可能な席位がまだありません。公開前に活動設計の席位を補完してください。",
            readonlyNotice:
              "この活動は下書き状態ではないため、メンバーと席位のスナップショットは読み取り専用です。",
          },
          topologyPreview: {
            title: "トポロジープレビュー",
            ariaLabel: "活動に紐付くトポロジーの X6 プレビュー",
            empty:
              "この活動のトポロジー紐付けにはプレビュー可能な X6 スナップショットがありません。",
          },
        },
      },
    },
  },
};
